module.exports = __webpack_public_path__ + "img/basket.be5030ca.webp";